<template>
    <v-card :loader="!isFetched">
        <div v-padding.left="3" v-padding.right="3" v-padding.top="2" v-padding.bottom="2">
            <v-text type="headline">
                Тарифы
            </v-text>
        </div>

        <div v-padding.left="3" v-padding.right="3" v-padding.bottom="2">
            <tariffs-table :tariffs="tariffs" :selected="profileTariff" />
        </div>
    </v-card>
</template>
<script>
    import { TariffsTable } from '../tariffsTable';
    import TariffsInfo from './TariffsInfo';

    export  default {
        name: 'tariff',
        props: {
            profileTariff: [String, Number],
            objectTariffs: {
                type: Object,
                default() {
                    return {};
                }
            },
            tariffs: {
                type: Array,
                default() {
                    return [];
                }
            },
            isFetched: Boolean,
        },
        components: {
            TariffsTable,
            TariffsInfo,
        },
    }
</script>


// WEBPACK FOOTER //
// Tariff.vue?06567850